import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=724e6ff8&scoped=true&"
import script from "./TextareaField.vue?vue&type=script&lang=ts&"
export * from "./TextareaField.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaField.vue?vue&type=style&index=0&id=724e6ff8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e6ff8",
  null
  
)

export default component.exports